module.exports = __webpack_public_path__ + "static/media/squared-cross.fa8fba2f.svg";